import { z } from "zod";

export const applyBaselineGuideSchema = z.object({
  /**
   * Rewrite a baseline guide item whose newest version is still a draft. An
   * approved version is never touched, so this cannot alter what a completed
   * review was measured against.
   */
  refreshDrafts: z.boolean().default(false),
  /** Overwrite dictionary entries that already exist with the baseline text. */
  replaceDictionary: z.boolean().default(false),
});
export type ApplyBaselineGuideInput = z.infer<typeof applyBaselineGuideSchema>;

export const applyBaselineGuideResultSchema = z.object({
  channelsCreated: z.number().int().nonnegative(),
  categoriesCreated: z.number().int().nonnegative(),
  guideItemsCreated: z.number().int().nonnegative(),
  guideItemsUpdated: z.number().int().nonnegative(),
  /** Items left alone because an administrator already approved or edited them. */
  guideItemsSkipped: z.number().int().nonnegative(),
  dictionaryCreated: z.number().int().nonnegative(),
  dictionaryUpdated: z.number().int().nonnegative(),
  dictionarySkipped: z.number().int().nonnegative(),
});
export type ApplyBaselineGuideResult = z.infer<typeof applyBaselineGuideResultSchema>;
